import React from "react";
import { Stack, Typography } from "@mui/material";
import { IconBackground, SelectIcon } from "components/icon";

const FormTitle = ({ title, logo, subTitle, icon = null }) => {
  return (
    <Stack
      spacing={1.5}
      direction="column"
      sx={{
        justifyContent: "center",
        alignItems: "center",
        flexGrow: 1,
        padding: "0px 32px",
      }}
    >
      <Stack
        spacing={1.5}
        direction="row"
        sx={{
          justifyContent: "center",
          alignItems: "center",
          flexGrow: 1,
        }}
      >
        <Typography variant="h2" gutterBottom>
          {title}
        </Typography>
        {/* {logo ? <img src={`${logo}`} alt="logo" width={`32px`} /> : null} */}
        {logo ? (
          <IconBackground>
            <img src={`${logo}`} alt="logo" width={"100%"} />
          </IconBackground>
        ) : null}
        {icon ? (
          <IconBackground>
            <SelectIcon value={icon} />
          </IconBackground>
        ) : null}
      </Stack>
      {subTitle ? (
        <Typography variant="subtitle1">{subTitle}</Typography>
      ) : null}
    </Stack>
  );
};

export default FormTitle;
